(function () {
  'use strict';
  class Controller {
    constructor() {}
  }
  angular
    .module('approval.updateReview', [])
    .component('approvalUpdateReview', {
      controller: Controller,
      templateUrl: 'root/approval/_components/updateReview/updateReview-approval.comp.html',
      bindings: {}
    });
}());
